// extracted by mini-css-extract-plugin
export var footer = "_r0-0";
export var inherit = "_r0-1";
export var input = "_r0-2";
export var modalContent = "_r0-3";
export var quillEditor = "_r0-4";
export var subtitle = "_r0-5";